var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSkuRecognition = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M18.7 22.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H21c.8 0 1.4-.6 1.4-1.4V5.5c0-.8-.6-1.4-1.4-1.4h-2.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H21c1.3 0 2.4 1.1 2.4 2.4v14.9c0 1.3-1.1 2.4-2.4 2.4zM5 22.8c-1.3-.1-2.3-1.1-2.3-2.4V5.5c0-1.3 1-2.4 2.3-2.4h2.4c.3 0 .5.2.5.5s-.2.5-.5.5L5 4.2c-.7 0-1.3.6-1.3 1.3v15c0 .7.5 1.3 1.2 1.4h2.4c.3 0 .5.2.5.5s-.2.5-.5.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M9.7 19.3H6.5c-.6 0-1.1-.5-1.1-1.1v-5.1c0-1.2.8-2.3 1.1-2.7V6.6c0-.5.4-.9.9-.9h1.3c.5 0 .9.4.9.9v3.8c.3.4 1.1 1.4 1.1 2.7v5.1c0 .6-.4 1.1-1 1.1M7.6 6.7v4.1l-.2.2s-.9 1-.9 2.2v5.1l3.2.1.1-5.2c0-1.1-.9-2.1-1-2.1l-.1-.1V6.9H7.6zm1.1 0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M9.1 7.8H7c-.1 0-.3-.1-.3-.3s.2-.2.3-.2h2.1c.1 0 .3.1.3.3s-.1.2-.3.2M10 17.8H5.9c-.1 0-.3-.1-.3-.3s.1-.3.3-.3H10c.1 0 .3.1.3.3s-.1.3-.3.3M14.2 19.3h-2.5V8.1h8.7v5c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-4h-6.7v9.2h1.5c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M19.8 10.8h-7.2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7.2c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "M20.4 19.3h-6.1v-1h5.1v-5.7h1z"
})));
export default SvgSkuRecognition;